var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 35,
    viewBox: "0 0 42 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7 Copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1304 0C25.5423 0 23.0189 2.64364 20.5413 5.83423C18.6602 2.27895 15.5862 0.0455936 11.9157 0.0455936C5.21709 0.0455936 0.904297 6.92817 0.904297 12.261C0.904297 23.0635 10.4475 28.8978 20.6789 28.8978V33.6501C20.6789 34.6569 21.752 35.311 22.6524 34.8489C31.3502 30.3845 41.0533 20.7846 41.0959 12.4434C41.0959 4.78588 36.2325 0 30.1304 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8278 13.4948H32.0921V15.2152C32.0921 16.1654 31.315 16.9356 30.3564 16.9356C29.3978 16.9356 28.6208 16.1654 28.6208 15.2152V13.4948H26.8851C25.9265 13.4948 25.1494 12.7245 25.1494 11.7743C25.1494 10.8241 25.9265 10.0539 26.8851 10.0539H28.6208V8.33347C28.6208 7.38327 29.3978 6.61304 30.3564 6.61304C31.315 6.61304 32.0921 7.38327 32.0921 8.33347V10.0539H33.8278C34.7863 10.0539 35.5634 10.8241 35.5634 11.7743C35.5634 12.7245 34.7863 13.4948 33.8278 13.4948Z",
    fill: "#FE9B50"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon);
export default __webpack_public_path__ + "static/media/modal_icon.6b98f57181daee37078a098eeaad6d54.svg";
export { ForwardRef as ReactComponent };